

            <app-splash-routing></app-splash-routing>
            <app-splash-screen></app-splash-screen>
            <router-outlet></router-outlet>


